export default {
    methods: {
        mixinsJobTable_FilterResult(result) {
            if (this.jobFilter.status) {
                result = result.filter(x => x.status === this.jobFilter.status);
            }
            if (this.jobFilter.keyword) {
                result = result.filter(x => x.bill.customerFirstName?.toLowerCase().indexOf(this.jobFilter.keyword.toLowerCase()) > -1
                                        || x.bill.customerLastName?.toLowerCase().indexOf(this.jobFilter.keyword.toLowerCase()) > -1
                                        || x.bill.customerTel?.toLowerCase().indexOf(this.jobFilter.keyword.toLowerCase()) > -1)
            }
            if (this.jobFilter.openDateFrom) {
                const filterDate = this.jobFilter.openDateFrom;
                filterDate.setHours(0, 0, 0, 0);

                result = result.filter(x => x.openDate.getTime() >= filterDate.getTime())
            }
            if (this.jobFilter.openDateTo) {
                const filterDate = this.jobFilter.openDateTo;
                filterDate.setHours(23, 59, 59, 0);

                result = result.filter(x => x.openDate.getTime() <= filterDate.getTime())
            }

            return result;
        },



        mixinsJobTable_GetStatusStyle(status) {
            let result = '';

            switch (status) {
                case this.$Constants.JOB_STATUS_PENDING:
                    result = 'pending';
                    break;

                case this.$Constants.JOB_STATUS_COMPLETE:
                    result = 'complete';
                    break;
            }

            return result;
        },
        mixinsJobTable_GetStatusOrderText(status) {
            let result = '';

            switch (status) {
                case this.$Constants.JOB_STATUS_PENDING:
                    result = 'อยู่ระหว่างบริการ';
                    break;

                case this.$Constants.JOB_STATUS_COMPLETE:
                    result = 'ออกบิลแล้ว';
                    break;
            }

            return result;
        },
        mixinsJobTable_GetStatusServiceText(status) {
            let result = '';

            switch (status) {
                case this.$Constants.JOB_STATUS_PENDING:
                    result = 'อยู่ระหว่างบริการ';
                    break;

                case this.$Constants.JOB_STATUS_COMPLETE:
                    result = 'บริการเสร็จแล้ว';
                    break;
            }

            return result;
        },
        mixinsJobTable_GetStatusClaimText(status) {
            let result = '';

            switch (status) {
                case this.$Constants.JOB_STATUS_PENDING:
                    result = 'ตรวจสอบข้อมูล';
                    break;

                case this.$Constants.JOB_STATUS_COMPLETE:
                    result = 'ออกใบเคลมแล้ว';
                    break;
            }

            return result;
        },
        mixinsJobTable_GetOrderType(type) {
            let text = '';

            switch (type) {
                case this.$Constants.JOB_FORM_WALKIN:
                    text = 'ลูกค้าทั่วไป'
                    break;

                case this.$Constants.JOB_FORM_FLEET:
                    text = 'ลูกค้าเครดิต';
                    break;

                case this.$Constants.JOB_FORM_ONLINE:
                    text = 'ลูกค้าออนไลน์';
                    break;

                case this.$Constants.JOB_FORM_STORE:
                    text = 'ลูกค้าร้านค้า';
                    break;
            }

            return text;
        },
        mixinsJobTable_GetPathName(type){
            let text = '';

            switch (type) {
                case this.$Constants.JOB_FORM_WALKIN:
                    text = 'walkin'
                    break;

                case this.$Constants.JOB_FORM_FLEET:
                    text = 'fleet';
                    break;

                case this.$Constants.JOB_FORM_ONLINE:
                    text = 'online';
                    break;

                case this.$Constants.JOB_FORM_STORE:
                    text = 'store';
                    break;
            }

            return text;
        },
        mixinsJobTable_GetStatusDisplay(status) {
            const result = { style: '', text: '' };

            switch (status) {
                case this.$Constants.JOB_STATUS_PENDING:
                    result.style = 'pending';
                    result.text = 'อยู่ระหว่างบริการ';
                    break;

                case this.$Constants.JOB_STATUS_COMPLETE:
                    result.style = 'complete';
                    result.text = 'ออกบิลแล้ว';
                    break;
            }

            return result;
        },
        mixinsJobTable_GetClaimStatusDisplay(status) {
            const result = { style: '', text: '' };

            switch (status) {
                case this.$Constants.JOB_STATUS_PENDING:
                    result.style = 'pending';
                    result.text = 'รอผลเคลม';
                    break;

                case this.$Constants.JOB_STATUS_COMPLETE:
                    result.style = 'complete';
                    result.text = 'ปิดเคลมแล้ว';
                    break;
            }

            return result;
        },
        mixinsJobTable_GetDifferenceDay(openDate) {
            const today = new Date();

            return Math.round((today - openDate) / (1000 * 60 * 60 *24));
        }
    }
}